import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { FiCircle } from "react-icons/fi";

export const UserMypageSettingIcon = ({ isProfileIncomplete }: { isProfileIncomplete: boolean }) => {
  return (
    <div className="relative w-8 h-8">
      <HiOutlineDotsHorizontal className="w-8 h-8 text-white" />
      {!isProfileIncomplete && (
        <FiCircle className="absolute right-0 top-0 w-3 h-3 text-red-500 fill-red-500" />
      )}
    </div>
  );
};